import { BonusRewardTypesQueryKeys } from '@/api/bonus-reward-type/queryKeys';
import { BonusRewardsQueryKeys } from '@/api/bonus-rewards/queryKey';
import { useLuckySpinsRewardsByLuckySpin } from '@/api/lucky-spin-rewards/queries/useLuckySpinRewardsByLuckySpin';
import { UserRewardsQueryKeys } from '@/api/user-rewards/queryKeys';
import { RootState } from '@/lib/store';
import {
  setLuckySpinIsPrizeDefined,
  setLuckySpinIsSpinning,
} from '@/lib/store/lucky-spin/actions';
import { LuckySpinId } from '@/models/user-reward/lucky-spin/namespace';
import { useSearchParams } from '@starsoft/common/hooks';
import { parseToBigInt } from '@starsoft/common/utils/parsers';
import { QueryClient, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';

export default function useLuckySpinState() {
  const search: URLSearchParams = useSearchParams();
  const dispatch: Dispatch<AnyAction> = useDispatch();
  const queryClient: QueryClient = useQueryClient();

  const isSpinning: boolean = useSelector(
    (state: RootState) => state.luckSpin.isSpinning,
  );

  const mode: string = (search.get('mode') as string) ?? '1';
  const rankName: string = LuckySpinId.idToGameName(
    parseToBigInt(mode) as bigint,
  );

  const useLuckySpinsRewardsByLuckySpinQuery = useLuckySpinsRewardsByLuckySpin({
    id: parseToBigInt(mode) as bigint,
  });

  function handleStopSpinning() {
    dispatch(setLuckySpinIsSpinning(false));
    dispatch(setLuckySpinIsPrizeDefined(true));
    queryClient.invalidateQueries({ queryKey: [UserRewardsQueryKeys.Me] });
    queryClient.invalidateQueries({ queryKey: [UserRewardsQueryKeys.ById] });
    queryClient.invalidateQueries({
      queryKey: [UserRewardsQueryKeys.Trackers],
    });
    queryClient.invalidateQueries({ queryKey: [BonusRewardsQueryKeys.ByUser] });
    queryClient.invalidateQueries({
      queryKey: [BonusRewardTypesQueryKeys.Statistics],
    });
  }

  return {
    handleStopSpinning,
    useLuckySpinsRewardsByLuckySpinQuery,
    rankName,
    isSpinning,
    mode,
  };
}
